export { TBodyMobile } from "./TBodyMobile";
export * from "./TBodyMobile.types";
